export default "__VITE_ASSET__CU8oraK7__"